import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  ConfigModule,
  ConfigValidatorModule,
  GlobalMessageModule,
  MetaTagConfigModule,
  ProcessModule,
  LazyLoadingModule,
  StateModule,
  ConfigInitializerModule,
  I18nModule,
  CmsModule,
  SiteContextModule,
  BaseOccModule,
  FeaturesConfigModule,
} from 'haba-core';
@NgModule({
  imports: [
    StateModule.forRoot(),
    ConfigModule.forRoot(),
    ConfigInitializerModule.forRoot(),
    ConfigValidatorModule.forRoot(),
    I18nModule.forRoot(), // NEEDED
    CmsModule.forRoot(), // NEEDED
    GlobalMessageModule.forRoot(),
    ProcessModule.forRoot(),
    FeaturesConfigModule.forRoot(),
    SiteContextModule.forRoot(), // should be imported after RouterModule.forRoot, because it overwrites UrlSerializer (NEEDED)
    MetaTagConfigModule.forRoot(),
    BaseOccModule.forRoot(), // NEEDED
    LazyLoadingModule.forRoot(),
  ],
})
export class BaseCoreModule {
  static forRoot(): ModuleWithProviders<BaseCoreModule> {
    return {
      ngModule: BaseCoreModule,
    };
  }
}
